'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import composeClasses from '@mui/utils/composeClasses';
import useId from '@mui/utils/useId';
import refType from '@mui/utils/refType';
import { styled } from "../zero-styled/index.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import Input from "../Input/index.js";
import FilledInput from "../FilledInput/index.js";
import OutlinedInput from "../OutlinedInput/index.js";
import InputLabel from "../InputLabel/index.js";
import FormControl from "../FormControl/index.js";
import FormHelperText from "../FormHelperText/index.js";
import Select from "../Select/index.js";
import { getTextFieldUtilityClass } from "./textFieldClasses.js";
import useSlot from "../utils/useSlot.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var variantComponent = {
    standard: Input,
    filled: FilledInput,
    outlined: OutlinedInput
};
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: [
            'root'
        ]
    };
    return composeClasses(slots, getTextFieldUtilityClass, classes);
};
var TextFieldRoot = styled(FormControl, {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        return styles.root;
    }
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ var TextField = /*#__PURE__*/ React.forwardRef(function TextField(inProps, ref) {
    var props = useDefaultProps({
        props: inProps,
        name: 'MuiTextField'
    });
    var autoComplete = props.autoComplete, _props_autoFocus = props.autoFocus, autoFocus = _props_autoFocus === void 0 ? false : _props_autoFocus, children = props.children, className = props.className, _props_color = props.color, color = _props_color === void 0 ? 'primary' : _props_color, defaultValue = props.defaultValue, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_error = props.error, error = _props_error === void 0 ? false : _props_error, FormHelperTextPropsProp = props.FormHelperTextProps, _props_fullWidth = props.fullWidth, fullWidth = _props_fullWidth === void 0 ? false : _props_fullWidth, helperText = props.helperText, idOverride = props.id, InputLabelPropsProp = props.InputLabelProps, inputPropsProp = props.inputProps, InputPropsProp = props.InputProps, inputRef = props.inputRef, label = props.label, maxRows = props.maxRows, minRows = props.minRows, _props_multiline = props.multiline, multiline = _props_multiline === void 0 ? false : _props_multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, _props_required = props.required, required = _props_required === void 0 ? false : _props_required, rows = props.rows, _props_select = props.select, select = _props_select === void 0 ? false : _props_select, SelectPropsProp = props.SelectProps, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, type = props.type, value = props.value, _props_variant = props.variant, variant = _props_variant === void 0 ? 'outlined' : _props_variant, other = _object_without_properties(props, [
        "autoComplete",
        "autoFocus",
        "children",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "error",
        "FormHelperTextProps",
        "fullWidth",
        "helperText",
        "id",
        "InputLabelProps",
        "inputProps",
        "InputProps",
        "inputRef",
        "label",
        "maxRows",
        "minRows",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "placeholder",
        "required",
        "rows",
        "select",
        "SelectProps",
        "slots",
        "slotProps",
        "type",
        "value",
        "variant"
    ]);
    var ownerState = _object_spread_props(_object_spread({}, props), {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    var classes = useUtilityClasses(ownerState);
    if (process.env.NODE_ENV !== 'production') {
        if (select && !children) {
            console.error('MUI: `children` must be passed when using the `TextField` component with `select`.');
        }
    }
    var id = useId(idOverride);
    var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
    var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
    var InputComponent = variantComponent[variant];
    var externalForwardedProps = {
        slots: slots,
        slotProps: _object_spread({
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp
        }, slotProps)
    };
    var inputAdditionalProps = {};
    var inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') {
            inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        }
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) {
            inputAdditionalProps.id = undefined;
        }
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    var _useSlot = _sliced_to_array(useSlot('root', {
        elementType: TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: _object_spread({}, externalForwardedProps, other),
        ownerState: ownerState,
        className: clsx(classes.root, className),
        ref: ref,
        additionalProps: {
            disabled: disabled,
            error: error,
            fullWidth: fullWidth,
            required: required,
            color: color,
            variant: variant
        }
    }), 2), RootSlot = _useSlot[0], rootProps = _useSlot[1];
    var _useSlot1 = _sliced_to_array(useSlot('input', {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    }), 2), InputSlot = _useSlot1[0], inputProps = _useSlot1[1];
    var _useSlot2 = _sliced_to_array(useSlot('inputLabel', {
        elementType: InputLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), InputLabelSlot = _useSlot2[0], inputLabelProps = _useSlot2[1];
    var _useSlot3 = _sliced_to_array(useSlot('htmlInput', {
        elementType: 'input',
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), HtmlInputSlot = _useSlot3[0], htmlInputProps = _useSlot3[1];
    var _useSlot4 = _sliced_to_array(useSlot('formHelperText', {
        elementType: FormHelperText,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), FormHelperTextSlot = _useSlot4[0], formHelperTextProps = _useSlot4[1];
    var _useSlot5 = _sliced_to_array(useSlot('select', {
        elementType: Select,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), SelectSlot = _useSlot5[0], selectProps = _useSlot5[1];
    var InputElement = /*#__PURE__*/ _jsx(InputSlot, _object_spread({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        }
    }, inputProps));
    return /*#__PURE__*/ _jsxs(RootSlot, _object_spread_props(_object_spread({}, rootProps), {
        children: [
            label != null && label !== '' && /*#__PURE__*/ _jsx(InputLabelSlot, _object_spread_props(_object_spread({
                htmlFor: id,
                id: inputLabelId
            }, inputLabelProps), {
                children: label
            })),
            select ? /*#__PURE__*/ _jsx(SelectSlot, _object_spread_props(_object_spread({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, selectProps), {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ _jsx(FormHelperTextSlot, _object_spread_props(_object_spread({
                id: helperTextId
            }, formHelperTextProps), {
                children: helperText
            }))
        ]
    }));
});
process.env.NODE_ENV !== "production" ? TextField.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: PropTypes.string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */ autoFocus: PropTypes.bool,
    /**
   * @ignore
   */ children: PropTypes.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: PropTypes.object,
    /**
   * @ignore
   */ className: PropTypes.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: PropTypes /* @typescript-to-proptypes-ignore */ .oneOfType([
        PropTypes.oneOf([
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        PropTypes.string
    ]),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: PropTypes.any,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: PropTypes.bool,
    /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */ error: PropTypes.bool,
    /**
   * Props applied to the [`FormHelperText`](https://mui.com/material-ui/api/form-helper-text/) element.
   * @deprecated Use `slotProps.formHelperText` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ FormHelperTextProps: PropTypes.object,
    /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */ fullWidth: PropTypes.bool,
    /**
   * The helper text content.
   */ helperText: PropTypes.node,
    /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */ id: PropTypes.string,
    /**
   * Props applied to the [`InputLabel`](https://mui.com/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   * @deprecated Use `slotProps.inputLabel` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ InputLabelProps: PropTypes.object,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.htmlInput` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ inputProps: PropTypes.object,
    /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](https://mui.com/material-ui/api/filled-input/),
   * [`OutlinedInput`](https://mui.com/material-ui/api/outlined-input/) or [`Input`](https://mui.com/material-ui/api/input/)
   * component depending on the `variant` prop value.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ InputProps: PropTypes.object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: refType,
    /**
   * The label content.
   */ label: PropTypes.node,
    /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */ margin: PropTypes.oneOf([
        'dense',
        'none',
        'normal'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */ multiline: PropTypes.bool,
    /**
   * Name attribute of the `input` element.
   */ name: PropTypes.string,
    /**
   * @ignore
   */ onBlur: PropTypes.func,
    /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: PropTypes.func,
    /**
   * @ignore
   */ onFocus: PropTypes.func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: PropTypes.string,
    /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */ required: PropTypes.bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    /**
   * Render a [`Select`](https://mui.com/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */ select: PropTypes.bool,
    /**
   * Props applied to the [`Select`](https://mui.com/material-ui/api/select/) element.
   * @deprecated Use `slotProps.select` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ SelectProps: PropTypes.object,
    /**
   * The size of the component.
   * @default 'medium'
   */ size: PropTypes /* @typescript-to-proptypes-ignore */ .oneOfType([
        PropTypes.oneOf([
            'medium',
            'small'
        ]),
        PropTypes.string
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: PropTypes /* @typescript-to-proptypes-ignore */ .shape({
        formHelperText: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ]),
        htmlInput: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ]),
        input: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ]),
        inputLabel: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ]),
        select: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: PropTypes.shape({
        formHelperText: PropTypes.elementType,
        htmlInput: PropTypes.elementType,
        input: PropTypes.elementType,
        inputLabel: PropTypes.elementType,
        root: PropTypes.elementType,
        select: PropTypes.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object,
            PropTypes.bool
        ])),
        PropTypes.func,
        PropTypes.object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */ type: PropTypes /* @typescript-to-proptypes-ignore */ .string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: PropTypes.any,
    /**
   * The variant to use.
   * @default 'outlined'
   */ variant: PropTypes.oneOf([
        'filled',
        'outlined',
        'standard'
    ])
} : void 0;
export default TextField;
